import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getdutytariffLibAsync,
  getdutytariffCountriesAsync,
  getdutytariffDestinationCountriesAsync,
} from 'src/redux/async/libraries/dutytariffasync'

const initialState = {
  dutytariffLibLoader: false,
  dutytariffLibError: '',
  dutytariffLib_state: [],

  dutytariffCountriesLoader: false,
  dutytariffCountriesError: '',
  dutytariffCountries: [],

  dutytariffDestinationCountriesLoader: false,
  dutytariffDestinationCountriesError: '',
  dutytariffDestinationCountries: [],
}

export const dutytariffLibrariesSlice = createSlice({
  name: 'dutytariffLibrariesData',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getdutytariffLibAsync.pending), (state) => {
      state.dutytariffLibLoader = true
    })
    builder.addMatcher(isAnyOf(getdutytariffLibAsync.fulfilled), (state, action) => {
      state.dutytariffLibLoader = false
      state.dutytariffLib_state = action.payload
      state.dutytariffLibError = ''
    })
    builder.addMatcher(isAnyOf(getdutytariffLibAsync.rejected), (state, action) => {
      state.dutytariffLibLoader = false
      state.dutytariffLibError = action.payload
    })

    builder.addMatcher(isAnyOf(getdutytariffCountriesAsync.pending), (state) => {
      state.dutytariffCountriesLoader = true
    })
    builder.addMatcher(isAnyOf(getdutytariffCountriesAsync.fulfilled), (state, action) => {
      state.dutytariffCountriesLoader = false
      state.dutytariffCountries = action.payload
      state.dutytariffCountriesError = ''
    })
    builder.addMatcher(isAnyOf(getdutytariffCountriesAsync.rejected), (state, action) => {
      state.dutytariffCountriesLoader = false
      state.dutytariffCountriesError = action.payload
    })

    builder.addMatcher(isAnyOf(getdutytariffDestinationCountriesAsync.pending), (state) => {
      state.dutytariffDestinationCountriesLoader = true
    })
    builder.addMatcher(isAnyOf(getdutytariffDestinationCountriesAsync.fulfilled), (state, action) => {
      state.dutytariffDestinationCountriesLoader = false
      state.dutytariffDestinationCountries = action.payload
      state.dutytariffDestinationCountriesError = ''
    })
    builder.addMatcher(isAnyOf(getdutytariffDestinationCountriesAsync.rejected), (state, action) => {
      state.dutytariffDestinationCountriesLoader = false
      state.dutytariffDestinationCountriesError = action.payload
    })
  },
})

export default dutytariffLibrariesSlice.reducer
